export default (opt = {}) => {
    let editor = opt.editor,
        styleManager = editor.StyleManager;

    const RENDER_DELAY_MS = 200;

    /**
     * Allow to toggle between two options
     *
     * @param {object} props
     * @param {int} props.default
     * @param {string} props.leftOptionValue
     * @param {string} props.rightOptionValue
     * @param {string} props.property
     * @param {string} props.label
     * @param {boolean} props.isResponsive
     * @param {grapesjs.Component} props.component
     * @param {function} [props.onToggleRight]  call back triggered when toggled on
     * @param {function} [props.onToggleLeft] call back triggered when toggled off
     * @param {string} props.type
     */
    styleManager.addType(window.PMW.emails.styles.ID_TOGGLE_BUTTON, {
        create({props, change}) {
            props.component = props.component || editor.getSelected();
            const currComponent = props.component,
                toggleSelector = document.createElement('div'),
                styles = currComponent.getStyle() || {};

            let isToggled = false;

            if (props.style && styles[props.style] === props.defaultSelectedStyle) {
                isToggled = true;
            }

            toggleSelector.className = props.type;
            toggleSelector.innerHTML = getToggleButtonsHtml(props, isToggled);

            if (props.isResponsive) {
                addResponsiveDeviceEvent(props);
            }

            attachToggleButtonHandler(props, change, toggleSelector);
            return toggleSelector;
        },

        emit({props}, {toggleEl, toggleId}) {
            $(toggleEl).addClass('-selected-comp').siblings('.toggle-option').removeClass('-selected-comp');
            props.component.set(props.property, toggleId);

            if (toggleId) {
                props.onToggleLeft(props.component);
            } else {
                props.onToggleRight(props.component);
            }
        }
    });

    /**
     * @param {object} props
     * @param {function} change
     * @param {HTMLElement} toggleSelector
     */
    function attachToggleButtonHandler(props, change, toggleSelector) {
        toggleSelector.querySelectorAll('.js-toggle-buttons').forEach(toggleEl => {
            const toggleId = parseInt(toggleEl.getAttribute('data-preset-id'));

            toggleEl.addEventListener('click', function (toggleSelector, toggleEl, toggleId) {
                change({toggleSelector, toggleEl, toggleId});
            }.bind(null, toggleSelector, toggleEl, toggleId));
        });
    }

    /**
     *
     * @param {Device} device
     * @param props
     */
    function onResponsiveDeviceChange(device, props) {
        const labelEl = $('.js-toggle-button-label');
        switch (device.get('name').toLowerCase()) {
            case window.PMW.emails.DEVICE_MOBILE:
                labelEl.html(getHighlightTag(device.get('name')) + props.label);
                labelEl.addClass('flex-v-row');
                break;
            case window.PMW.emails.DEVICE_TABLET:
                labelEl.html(getHighlightTag(device.get('name')) + props.label);
                labelEl.addClass('flex-v-row');
                break;
            case window.PMW.emails.DEVICE_DESKTOP:
                labelEl.html(props.label);
                labelEl.removeClass('flex-v-row');
                break;
        }
    }

    function getHighlightTag(tagName) {
        return `<span class="highlight-tag body-xxs-bold -rounded">${tagName}</span>`
    }

    function addResponsiveDeviceEvent(props) {
        const currentDevice = editor.DeviceManager.getSelected();

        if (currentDevice) {
            setTimeout(() => {
                onResponsiveDeviceChange(currentDevice, props);
            }, RENDER_DELAY_MS);
        }

        editor.on('device:select', (newDevice) => {
            onResponsiveDeviceChange(newDevice, props);
        })
    }

    /**
     * @param {object} props
     * @param {string} props.leftOptionValue
     * @param {string} props.rightOptionValue
     * @param {string} props.label
     * @param {boolean} isToggled
     * @return {string}  containing markup for toggle button
     */
    function getToggleButtonsHtml(props, isToggled) {
        return `<div class="flexbox flex-content-between flex-align-items-center">
             <label class="toggle-text body-xs js-toggle-button-label">${props.label}</label>
            <div class="toggle-switch flexbox flex-h-row flex-content-between _fit-width border-s-dark radius-8">
            <span data-preset-id = "${window.PMW.emails.TOGGLE_OPTION_PRESET_ID_ONE}" class="flexbox flex-content-center body-xs-bold toggle-option js-toggle-buttons radius-4 _cursor-pointer spacing-m-l-1 spacing-m-r-1 ${isToggled ? '-selected-comp' : ''}"> ${props.leftOptionValue}</span>
            <span data-preset-id = "${window.PMW.emails.TOGGLE_OPTION_PRESET_ID_ZERO}" class="flexbox flex-content-center body-xs-bold toggle-option js-toggle-buttons radius-4 _cursor-pointer spacing-m-r-1 ${!isToggled ? '-selected-comp' : ''}"> ${props.rightOptionValue}</span>
            </div>
        </div>`
    }
};